import { DEFAULT_WHITELISTED_TAGS } from 'Src/constants'
import * as DOMPurify from 'dompurify'

const DEFAULT_TAGS_TO_REMOVE = ['script', 'iframe', 'style', 'svg', 'img', 'figure', 'video', 'table', 'hr']

export const domPurifySpecifiedTagsAndRemoveContent = (html = '', tagsToRemove = DEFAULT_TAGS_TO_REMOVE) => {
  return DOMPurify.sanitize(html, {
    FORBID_TAGS: tagsToRemove,
    KEEP_CONTENT: false
  })
}

export const domPurifyAllTagsAndKeepContent = (html = '') => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [],
    KEEP_CONTENT: true
  })
}

export const domPurifyKeepSpecificTagsAndContent = (html = '', allowedTags = DEFAULT_WHITELISTED_TAGS) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedTags,
    KEEP_CONTENT: true
  })
}
